import { type ChatIntroVideo } from '@/shared-ui';
import { ProjectType } from '@/survey-graphql';

interface ChatPropsProject {
  isAiVoiceEnabled?: boolean | null;
  isUserVoiceEnabled?: boolean | null;
  introText?: string | null;
  introVideo?: ChatIntroVideo | null;
  language?: string | null;
  type?: ProjectType | null;
  settings?: {
    isAiVoiceEnabled?: boolean | null;
    isUserVoiceEnabled?: boolean | null;
    introText?: string | null;
  } | null;
}

interface OrgSettings {
  avatarUrl?: string | null;
  logoUrl?: string | null;
  brandColor?: string | null;
}

interface ResponseState {
  isSaving: boolean;
  isSubmitting: boolean;
  isConversationOver: boolean;
}

interface GetProjectChatPropsParams {
  project: ChatPropsProject;
  orgSettings?: OrgSettings | null;
  responseState: ResponseState;
}

export function getProjectChatProps({
  project,
  orgSettings,
  responseState,
}: GetProjectChatPropsParams) {
  const { isSaving, isSubmitting, isConversationOver } = responseState;

  const isUserVoiceEnabled = () => {
    if (project?.type === ProjectType.UsabilityTesting) {
      return false;
    }
    return (
      project?.settings?.isUserVoiceEnabled ??
      project?.isUserVoiceEnabled ??
      false
    );
  };

  return {
    disabled: isSaving || isConversationOver || isSubmitting,
    loading: isSaving || isSubmitting,
    avatarUrl: orgSettings?.avatarUrl || undefined,
    isAiVoiceEnabled:
      project?.settings?.isAiVoiceEnabled ?? project?.isAiVoiceEnabled ?? false,
    isUserVoiceEnabled: isUserVoiceEnabled(),
    introText: project?.settings?.introText ?? project?.introText,
    introVideo: project?.introVideo,
    projectType: project?.type ?? undefined,
    numeralLocale: project?.language ?? null,
  };
}
